/**
 * Detects if the browser is likely being automated (e.g., Cypress, Playwright, Selenium).
 * @returns {boolean} True if automation is detected, false otherwise.
 */
export const isAutomatedBrowser = () => {
  const windowProps = [
    "Cypress", // Cypress adds a global `Cypress` object
    "_playwright", // Playwright-specific property
    "_selenium", // Possible custom Selenium property
    "__webdriver_evaluate", // Sometimes left by Selenium
    "__driver_evaluate",
    "__webdriver_script_function",
    "__webdriver_script_func",
    "__webdriver_script_fn",
    "__webdriver_evaluation",
    "__selenium_unwrapped",
    "__fxdriver_evaluate",
    "__fxdriver_unwrapped",
  ];

  const userAgentIndicators = [
    "HeadlessChrome", // Chrome in headless mode
    "Chrome-Lighthouse", // Used by Lighthouse for auditing
    "Cypress", // Cypress adds its name in some cases
    "Playwright", // Playwright user agents may include this
    "puppeteer", // Puppeteer-like user agents
    "WebDriver", // Selenium WebDriver
    "PhantomJS", // Legacy headless browser
  ];

  // Check window properties
  for (const prop of windowProps) {
    if (/** @type {any} */ (window)[prop] !== undefined) {
      return true;
    }
  }

  // Check userAgent string
  const userAgent = navigator.userAgent || "";
  for (const indicator of userAgentIndicators) {
    if (userAgent.includes(indicator)) {
      return true;
    }
  }

  // Check WebDriver flag
  if (navigator.webdriver) {
    return true;
  }

  // No indicators found
  return false;
};
